import { Link } from 'react-router-dom';

export default function MobileBottomBar() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-saffron/20"
      style={{ background: 'linear-gradient(135deg, #1E0D05 0%, #2A1A0E 100%)' }}
    >
      <div className="grid grid-cols-3 divide-x divide-white/10">
        <a
          href="tel:+18645550123"
          className="flex flex-col items-center justify-center py-3.5 gap-1 cursor-pointer hover:bg-saffron/10 transition-colors"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-phone-line text-saffron text-lg"></i>
          </div>
          <span className="font-sans text-[10px] text-white/70 font-medium">Call</span>
        </a>
        <Link
          to="/menu"
          className="flex flex-col items-center justify-center py-3.5 gap-1 cursor-pointer hover:bg-saffron/10 transition-colors"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-restaurant-2-line text-saffron text-lg"></i>
          </div>
          <span className="font-sans text-[10px] text-white/70 font-medium">Menu</span>
        </Link>
        <a
          href="tel:+18645550123"
          className="flex flex-col items-center justify-center py-3.5 gap-1 cursor-pointer bg-saffron hover:bg-coral transition-colors"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-calendar-2-line text-white text-lg"></i>
          </div>
          <span className="font-sans text-[10px] text-white font-semibold">Reserve</span>
        </a>
      </div>
    </div>
  );
}
